module.exports = __webpack_public_path__ + "static/media/mindfulness-for-financial-stress@3x.94815ff3.png";